__turbopack_context__.v({
  "action": "SectionHeader-module__YaysOW__action",
  "compact": "SectionHeader-module__YaysOW__compact",
  "description": "SectionHeader-module__YaysOW__description",
  "display": "SectionHeader-module__YaysOW__display",
  "eyebrow": "SectionHeader-module__YaysOW__eyebrow",
  "header": "SectionHeader-module__YaysOW__header",
  "text": "SectionHeader-module__YaysOW__text",
  "title": "SectionHeader-module__YaysOW__title",
});
